import type { Lang } from './types';

export interface Translations {
  loginTagline: string; signInTitle: string; email: string; password: string;
  roleSelector: string; roleHint: string; signIn: string; or: string; sso: string;
  supplierQ: string; registerHere: string; complianceQ: string; submitAnon: string;
  loginFooter: string; notifications: string; unread: string; markAllRead: string;
  switchRole: string; logout: string; activeRfqs: string; recentActivity: string;
  supplierReviews: string; expiringContracts: string; searchRfq: string; allStatus: string;
  allCategories: string; export: string; awardRec: string; awardOverride: string; negotiate: string;
}

const en: Translations = {
  loginTagline: 'ACME Group — AI Procurement Platform', signInTitle: 'Sign in to your account',
  email: 'Email', password: 'Password', roleSelector: 'Role (mockup selector)',
  roleHint: 'Demo only — pick a role to preview its screens.', signIn: 'Sign In', or: 'or',
  sso: 'Sign in with Microsoft SSO', supplierQ: 'Are you a supplier?', registerHere: 'Register here',
  complianceQ: 'Need to report a concern?', submitAnon: 'Submit anonymously',
  loginFooter: 'Protected by corporate IT Security Policy. All access is logged and monitored.',
  notifications: 'Notifications', unread: 'unread', markAllRead: 'Mark all read', switchRole: 'Switch role',
  logout: 'Logout', activeRfqs: 'Active RFQs', recentActivity: 'Recent Activity',
  supplierReviews: 'Supplier Reviews', expiringContracts: 'Expiring Contracts',
  searchRfq: 'Search RFQ ID or title…', allStatus: 'All statuses', allCategories: 'All categories',
  export: 'Export', awardRec: 'Award (Recommended)', awardOverride: 'Award (Override)', negotiate: 'Negotiate',
};

const th: Translations = {
  loginTagline: 'ACME Group — แพลตฟอร์มจัดซื้อด้วย AI', signInTitle: 'เข้าสู่ระบบบัญชีของคุณ',
  email: 'อีเมล', password: 'รหัสผ่าน', roleSelector: 'บทบาท (ตัวเลือกจำลอง)',
  roleHint: 'สำหรับสาธิตเท่านั้น — เลือกบทบาทเพื่อดูหน้าจอ', signIn: 'เข้าสู่ระบบ', or: 'หรือ',
  sso: 'เข้าสู่ระบบด้วย Microsoft SSO', supplierQ: 'เป็นซัพพลายเออร์ใช่ไหม?', registerHere: 'ลงทะเบียนที่นี่',
  complianceQ: 'ต้องการรายงานข้อกังวล?', submitAnon: 'ส่งแบบไม่ระบุตัวตน',
  loginFooter: 'ได้รับการคุ้มครองโดยนโยบายความปลอดภัยไอทีขององค์กร ทุกการเข้าถึงถูกบันทึกและตรวจสอบ',
  notifications: 'การแจ้งเตือน', unread: 'ยังไม่อ่าน', markAllRead: 'ทำเครื่องหมายว่าอ่านแล้ว', switchRole: 'สลับบทบาท',
  logout: 'ออกจากระบบ', activeRfqs: 'ใบขอเสนอราคาที่ใช้งาน', recentActivity: 'กิจกรรมล่าสุด',
  supplierReviews: 'การตรวจสอบซัพพลายเออร์', expiringContracts: 'สัญญาที่ใกล้หมดอายุ',
  searchRfq: 'ค้นหารหัสหรือชื่อ RFQ…', allStatus: 'ทุกสถานะ', allCategories: 'ทุกหมวดหมู่',
  export: 'ส่งออก', awardRec: 'มอบสัญญา (แนะนำ)', awardOverride: 'มอบสัญญา (แทนที่)', negotiate: 'เจรจา',
};

export function T(lang: Lang): Translations {
  return lang === 'th' ? th : en;
}

const navEn: Record<string, string> = {
  dashboard: 'Dashboard', rfq: 'RFQ Management', incoming: 'Incoming PR / RFQ', po: 'PO Management',
  invoice: 'Invoice Matching', contract: 'Contract Management', batch: 'Insurance Batch RFQ',
  asl: 'ASL Management', review: 'Supplier Review', doa: 'DOA Approval', exec: 'Executive Dashboard',
  fraud: 'Fraud Dashboard', audit: 'Audit Trail', myboard: 'My Dashboard', bidsubmit: 'Bid Submission',
  myorders: 'My Purchase Orders', feedback: 'Feedback', whpo: 'Purchase Orders', users: 'User Management',
  settings: 'Master Settings', reports: 'Report Submissions',
};

const navTh: Record<string, string> = {
  dashboard: 'แดชบอร์ด', rfq: 'จัดการใบขอเสนอราคา', incoming: 'ใบขอซื้อ / RFQ', po: 'ใบสั่งซื้อ',
  invoice: 'ใบแจ้งหนี้ / จับคู่ 3 ทาง', contract: 'จัดการสัญญา', batch: 'RFQ ประกันภัยแบบชุด',
  asl: 'จัดการรายชื่อผู้ขาย', review: 'ตรวจสอบซัพพลายเออร์', doa: 'อนุมัติ DOA', exec: 'แดชบอร์ดผู้บริหาร',
  fraud: 'แดชบอร์ดทุจริต', audit: 'บันทึกการตรวจสอบ', myboard: 'แดชบอร์ดของฉัน', bidsubmit: 'ยื่นข้อเสนอราคา',
  myorders: 'ใบสั่งซื้อของฉัน', feedback: 'ความคิดเห็น', whpo: 'ใบสั่งซื้อ', users: 'จัดการผู้ใช้', settings: 'ตั้งค่าระบบ',
  reports: 'รายงานที่ส่งเข้ามา',
};

export function navLabels(lang: Lang): Record<string, string> {
  return lang === 'th' ? navTh : navEn;
}
